export const CANCEL_REASON_DESCRIPTIONS: Readonly<Record<string, string>> = {
  'Нецелевое обращение':
    'Звонок по вопросам, не связанным с изделиями из ПВХ или алюминия: покупка или продажа имущества, сторонние услуги, справочная, ошибочный номер, отсутствие запроса, реклама.',
  'Некорректный номер': 'В заявке указан номер, по которому невозможно дозвониться.',
  'Уже неактуально (до КП)':
    'К моменту звонка клиент уже решил вопрос, и мы не успели уточнить его потребность.',
  'Нерентабельный заказ':
    'Заказ экономически нецелесообразен: компании невыгодно заниматься его выполнением.',
  'Технический отказ':
    'Заказ невозможно выполнить из-за отсутствия технической возможности, даже если он экономически выгоден.',
  'Сроки не устроили':
    'Клиенту нужен более короткий срок, чем доступный срок изготовления или выполнения заказа.',
  'Дорого, не прошли по цене':
    'Клиента не устроила цена. Обязательно укажите предложение конкурента в предусмотренном для этого поле.',
  'Нужна рассрочка': 'Клиенту нужна рассрочка, которую компания не может предоставить.',
  'Отказ до выезда на замер':
    'Замер был согласован, но при последующем уточнении клиент от него отказался.',
  'Личные причины':
    'Клиент не называет истинную причину отказа или перестаёт выходить на связь после первичного обращения, в том числе в чатах Авито.',
  Отказ:
    'Клиент не называет истинную причину отказа или перестаёт выходить на связь после первичного обращения, в том числе в чатах Авито.',
  'Не отвечает на сообщения/звонки после КП':
    'Коммерческое предложение подготовлено, но после его получения клиент больше не отвечает на сообщения и звонки.',
  Тест: 'Пробное обращение, созданное для проверки работы системы.',
  Дубль: 'Повторное обращение, случайно созданное для того же клиента.',
  Рекламация:
    'Заказ уже закрыт, но клиент обратился по рекламации, и в системе автоматически создалось новое обращение.',
  'Конкуренты-прозвон цен':
    'Обращение от конкурента, который собирает информацию о ценах под видом потенциального клиента.',
}

export function getCancelReasonDescription(reason: unknown): string | undefined {
  return typeof reason === 'string' ? CANCEL_REASON_DESCRIPTIONS[reason] : undefined
}
